var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-top"},[_c('div',{staticClass:"brand-top__container"},_vm._l((_vm.brands),function(ref){
var data = ref.data;
var id = ref.id;
return _c('g-brand-card',{key:id,attrs:{"name":data.base.name,"logo":data.base.logo,"image":data.base.image,"onClickEdit":_vm.onClickEdit(id),"owner":_vm.owner}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }